import React, {useState, useEffect} from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CloseIcon from "@material-ui/icons/Close";
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { connect } from "react-redux";


import { 
    Dialog, 
    DialogTitle, 
    IconButton, 
    DialogContent, 
    CircularProgress,
    DialogActions,
    withStyles,
    Typography,
    Button,
    TextField
} from "@material-ui/core";

import styles from "../IntentClassification/styles.js";

const EntityMapDialog = props =>{

const [selectedValue, setValue] = useState(null);
const [selectedRole, setRole] = useState(null);

const filter = createFilterOptions(); 
const{
    classes, 
    dropdownEntities, 
    isLoading, 
    show,
    handleEntityMap,
    closeModal} = props;

return(
<Dialog open={show}>
<DialogTitle disableTypography className={classes.modalTitle}>
  <Typography variant="h5">
    Set entity type for: 
    <span className={classes.modalTitleLight}> "{props.selectedText}" </span>
  </Typography> 
   {closeModal ? (
     <IconButton aria-label="close" className={classes.closeButton} onClick={props.closeModal}>
       <CloseIcon />
     </IconButton>
   ) : null}
</DialogTitle>
<DialogContent className={classes.formContent} dividers>
  <Autocomplete
   classes={{
      groupLabel: classes.groupLabel,
  }}
  options={dropdownEntities?[...dropdownEntities].sort((a,b) => -b.name[0].localeCompare(a.name[0])):[]}
  getOptionLabel={(option) => {
    if (typeof option === 'string') return option;
    if (option.inputValue) return option.inputValue;
    else return option.name;
    }}
  style={{ width: 220 }}
  groupBy={(option) => {
    if (typeof option === 'string') {
      return option[0].toUpperCase();
    }
    if (option.inputValue) {
      return option.inputValue[0].toUpperCase();
    }
    return option.name[0].toUpperCase();
    } }
    renderInput={(params) => <TextField {...params}  InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="primary" size={22} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }} label="Enter entity type" variant="outlined" />}
  value={props.selectedValue}
  freeSolo
  renderOption={(option) => option.name}
  loading={isLoading}
  onChange={(event, newVal) => {
  if (newVal && newVal.inputValue){
      setValue({name:newVal.inputValue, role:[]})
  }else {
      setValue(newVal)}
  }}
  filterOptions={(options, params) => {
  const filtered = filter(options, params);
    if (params.inputValue !== '') {
    filtered.push({
          inputValue: params.inputValue,
          name: `Set "${params.inputValue}" as entity type`
      });}
    return filtered;
    }} 
  /> 
  <Autocomplete
    freeSolo
    disabled={!selectedValue}
    classes={{ groupLabel: classes.groupLabel }}
    options={selectedValue?selectedValue.role:[]}
    getOptionLabel={(option) => {
      if (typeof option === 'string') return option;
      if (option.inputValue) return option.inputValue;
      else return option;
      }}
    style={{ width: 220 }}
    renderInput={(params) => <TextField {...params} 
       InputProps={{
         ...params.InputProps,
         endAdornment: (
           <React.Fragment>
             {isLoading ? <CircularProgress color="primary" size={22} /> : null}
             {params.InputProps.endAdornment}
           </React.Fragment>
         ),
       }} label="Enter entity type role" variant="outlined" />}
    value={selectedRole}
    renderOption={(option) => { 
      if(option.inputValue)return option.name
      else return option}}
    loading={isLoading}
    onChange={(event, newVal) => { 
      if (newVal && newVal.inputValue){
          setRole(newVal.inputValue)
      }else {
          setRole(newVal)}
      }}
    filterOptions={(options, params) => {
    const filtered = filter(options, params);
      if (params.inputValue !== '') {
      filtered.push({
            inputValue: params.inputValue,
            name: `Set "${params.inputValue}" as a role`
      });}
    return filtered;
    }} 
  /> 
</DialogContent>
<DialogActions>
  <Button autoFocus onClick={() => handleEntityMap(selectedValue, selectedRole)} color="primary">
    Save
  </Button>
</DialogActions>
</Dialog>
)}

function mapStateToProps(state) {
    return {
      dropdownEntities: state.utterance.dropdownEntities, 
    }
}

let ConnectedDialog = connect(
    mapStateToProps,
  )(EntityMapDialog);

export default withStyles(styles)(ConnectedDialog);
